var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourtBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.89899 2 2.69002 5.0555 2.07685 9.00351C1.99209 9.54925 2.44774 10 3.00002 10H4V21.25H3.5C3.08579 21.25 2.75 21.5858 2.75 22C2.75 22.4142 3.08579 22.75 3.5 22.75H9.5C9.91421 22.75 10.25 22.4142 10.25 22C10.25 21.5858 9.91421 21.25 9.5 21.25H9V10H15.5V21.25H15C14.5858 21.25 14.25 21.5858 14.25 22C14.25 22.4142 14.5858 22.75 15 22.75H21C21.4142 22.75 21.75 22.4142 21.75 22C21.75 21.5858 21.4142 21.25 21 21.25H20.5V10H21C21.5523 10 22.008 9.54925 21.9232 9.00351C21.31 5.0555 17.1011 2 12 2ZM8.25002 6C8.25002 5.58579 8.58581 5.25 9.00002 5.25H15C15.4142 5.25 15.75 5.58579 15.75 6C15.75 6.41421 15.4142 6.75 15 6.75H9.00002C8.58581 6.75 8.25002 6.41421 8.25002 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtBuilding);
export default __webpack_public_path__ + "static/media/court-building.3806188b43c990e1039569caeb92a527.svg";
export { ForwardRef as ReactComponent };